import { TonChainID, isTonTransaction, } from '../../shared/txs/ton.js';
export { TonChainID, isTonTransaction };
//# sourceMappingURL=ton.js.map